import { AdvancedDynamicTexture } from "@babylonjs/gui/2D/advancedDynamicTexture";
import { Scene } from "@babylonjs/core/scene";

const MIN_GUI_REFERENCE_WIDTH = 960;
const MAX_GUI_REFERENCE_WIDTH = 1366;

function getIdealWidth(scene: Scene): number {
  const renderWidth = scene.getEngine().getRenderingCanvas()?.clientWidth ?? window.innerWidth;
  return Math.max(MIN_GUI_REFERENCE_WIDTH, Math.min(MAX_GUI_REFERENCE_WIDTH, renderWidth));
}

/**
 * Babylon GUI scales controls relative to idealWidth. The project originally
 * used a 1920px reference across the board, which shrank every menu and HUD
 * element on the 1024px Playwright viewport and on common laptop widths.
 */
export function configureResponsiveFullscreenUI(
  gui: AdvancedDynamicTexture,
  scene: Scene,
): () => void {
  const engine = scene.getEngine();

  const apply = () => {
    gui.idealWidth = getIdealWidth(scene);
  };

  apply();
  const resizeObserver = engine.onResizeObservable.add(apply);

  return () => {
    if (resizeObserver) {
      engine.onResizeObservable.remove(resizeObserver);
    }
  };
}
